export const patientTableState = {
  page: 0,
  pageSize: 25,
  filters: [],
  searchText: "",
  orderBy: "",
  orderDirection: "asc",
  fetchTableData: false,
  refreshDeviceAlertList: false,
  isPatientEnrollModal: false,
  pagination: {
    pageIndex: 0,
    pageSize: 10,
  },
  search: "",
  showPatientAlert: false,
  showDeviceAlert: false,
  showMissingContactInfo: false,
  showAlertWhenDisconnected: false,
  totalSelectedRows: 0,
  selectedPatients: [],
};
